import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import { NAV } from "@/lib/constants";
import { useSite } from "@/context/SiteContext";
import { Button } from "@/components/ui/button";

export default function Header() {
  const { config, categories, openQuote } = useSite();
  const [open, setOpen] = useState(false);
  const [equipOpen, setEquipOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-[#27272A] bg-[#0A0A0B]">
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-4 py-3 lg:px-8">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <img src={config?.logo} alt="Global Refrigeração" className="h-10 w-auto" />
          <div className="hidden leading-none sm:block">
            <div className="font-heading text-base font-black tracking-tight text-white">GLOBAL REFRIGERAÇÃO</div>
            <div className="text-[0.62rem] uppercase tracking-[0.18em] text-[#A1A1AA]">Fabricante de Equipamentos</div>
          </div>
        </Link>

        <nav className="hidden items-center gap-1 xl:flex">
          {NAV.map((n) =>
            n.to === "/equipamentos" ? (
              <div key={n.to} className="relative" onMouseEnter={() => setEquipOpen(true)} onMouseLeave={() => setEquipOpen(false)}>
                <NavLink to={n.to} data-testid={`nav-${n.label}`} className="flex items-center gap-1 px-3 py-2 text-sm font-medium text-[#A1A1AA] transition-colors duration-200 hover:text-white">
                  {n.label} <ChevronDown className="h-3.5 w-3.5" />
                </NavLink>
                {equipOpen && (
                  <div className="absolute left-0 top-full grid w-[520px] grid-cols-2 gap-1 border border-[#27272A] bg-[#0A0A0B] p-3">
                    {categories.map((c) => (
                      <Link key={c.slug} to={`/equipamentos/${c.slug}`} className="px-3 py-2 text-sm text-[#A1A1AA] transition-colors duration-200 hover:bg-[#1E1F22] hover:text-[#FF5500]">
                        {c.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <NavLink key={n.to} to={n.to} data-testid={`nav-${n.label}`}
                className={({ isActive }) => `px-3 py-2 text-sm font-medium transition-colors duration-200 hover:text-white ${isActive ? "text-white" : "text-[#A1A1AA]"}`}>
                {n.label}
              </NavLink>
            )
          )}
        </nav>

        <div className="flex items-center gap-2">
          <Button data-testid="header-quote-button" onClick={() => openQuote()} className="hidden rounded-none bg-[#FF5500] font-bold hover:bg-[#CC4400] sm:inline-flex">
            Solicitar Orçamento
          </Button>
          <button data-testid="mobile-menu-toggle" className="xl:hidden" onClick={() => setOpen(!open)}>
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-[#27272A] bg-[#0A0A0B] px-4 py-3 xl:hidden">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)}
              className="block py-2 text-sm font-medium text-[#A1A1AA] hover:text-white">
              {n.label}
            </NavLink>
          ))}
          <Button onClick={() => { setOpen(false); openQuote(); }} className="mt-3 w-full rounded-none bg-[#FF5500] font-bold hover:bg-[#CC4400]">
            Solicitar Orçamento
          </Button>
        </div>
      )}
    </header>
  );
}
